import { apiService } from '@shared/services/apiServices';
import type {
  ListSubscriptionsResponse,
  ListSubscriptionsParams,
} from '../types/subscriptionListType';

export const listSubscriptionApiService = {
  listSubscriptions: async (
    params?: ListSubscriptionsParams
  ): Promise<ListSubscriptionsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.status) {
      queryParams.append('status', params.status);
    }
    if (params?.billingCycle) {
      queryParams.append('billingCycle', params.billingCycle);
    }
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    const endpoint = `loopay-subscription-management/subscriptions${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiService.getAPI(endpoint);

    if (response.error) {
      // Return empty result for 404 (no matching subscriptions)
      return {
        success: true,
        data: [],
        totalCount: 0,
        page: params?.page || 1,
        limit: params?.limit || 10,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
      };
    }

    return response.data as ListSubscriptionsResponse;
  },
};
